export default function currency(value, promoType = '', decimalPlaces = 2) {
    const isWeightTypePromo = promoType.includes('Weight')
    const perKg = isWeightTypePromo ? ' / kg' : ''

    const formattedValue = new Intl.NumberFormat('pl-PL', {
        style: 'decimal',
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
        useGrouping: true
    }).format(value)

    return `${formattedValue} zł${perKg}`
}
